import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['frame', 'completionForm']
  static values = { launchUrl: String, targetOrigin: String, sessionId: String }

  connect() {
    this.completed = false
    this.boundHandleMessage = this.handleMessage.bind(this)
    window.addEventListener('message', this.boundHandleMessage)
    this.frameTarget.src = this.launchUrlValue
  }

  disconnect() {
    window.removeEventListener('message', this.boundHandleMessage)
  }

  handleMessage(event) {
    if (this.completed) return
    if (event.origin !== this.targetOriginValue) return
    if (event.source !== this.frameTarget.contentWindow) return
    if (!event.data || typeof event.data !== 'object') return
    if (event.data.type !== 'VOICE_AGENT_COMPLETED') return
    if (event.data.sessionId !== this.sessionIdValue) return

    this.completed = true
    this.completionFormTarget.submit()
  }
}